<div class="fieldset {{ size() }}" [class.scroll]="scroll()">
  @if (headline().length > 0) {
    <div class="headline">
      <h3>{{ headline() }}</h3>
    </div>
  }
  <div class="content {{ direction() }}">
    <ng-content></ng-content>
  </div>
</div>
